"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var h = require("./../../utils/createElement").h;
var React = tslib_1.__importStar(require("react"));
var PropTypes = tslib_1.__importStar(require("prop-types"));
var react_dom_1 = tslib_1.__importDefault(require("react-dom"));
var helper_1 = require("../../utils/helper");
var Trigger_1 = tslib_1.__importDefault(require("../../utils/Trigger"));
var theme_1 = require("../../utils/theme");
var ARROW_GAP = 6;
var CONTENT_MARGIN = 12;
var Popover = (function (_super) {
    tslib_1.__extends(Popover, _super);
    function Popover() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { visible: false };
        _this.arrowRef = React.createRef();
        _this.contentRef = React.createRef();
        _this.anchorRef = React.createRef();
        _this.prevPostionInfo = {
            arrowPosition: {}, contentPosition: {}, resolvedPlacement: 'bottom'
        };
        _this.hide = function () {
            if (_this.props.disabled) {
                return;
            }
            _this.setState({ visible: false }, _this.determineVisibleChange(false));
        };
        _this.toggle = function () {
            if (_this.props.disabled) {
                return;
            }
            var visible = !_this.isVisible();
            _this.setState({ visible: visible }, _this.determineVisibleChange(visible));
        };
        _this.stopPropagation = function (e) {
            e.stopPropagation();
        };
        _this.themedRender = function (classNames) {
            var _a, _b;
            var _c = _this.props, prefixCls = _c.prefixCls, className = _c.className, style = _c.style, children = _c.children, popContent = _c.popContent, disabled = _c.disabled, popContentStyle = _c.popContentStyle, arrowStyle = _c.arrowStyle, zIndex = _c.zIndex;
            var visible = _this.isVisible();
            var classes = classNames(prefixCls, className, (_a = {},
                _a[prefixCls + "-disabled"] = disabled,
                _a));
            var contentClasses = classNames(prefixCls + "-content");
            var containerClasses = classNames(prefixCls + "-container", (_b = {},
                _b[prefixCls + "-container-hidden"] = !visible,
                _b));
            var _d = _this.calcPosition(), arrowPosition = _d.arrowPosition, contentPosition = _d.contentPosition, resolvedPlacement = _d.resolvedPlacement;
            var arrowClasses = classNames(prefixCls + "-arrow", prefixCls + "-arrow-" + resolvedPlacement);
            return (h(Trigger_1.default, { className: classes, style: style, action: _this.hide },
                h("div", { onClick: _this.toggle, ref: _this.anchorRef }, children),
                react_dom_1.default.createPortal(h("div", { className: containerClasses },
                    h("div", { className: contentClasses, style: tslib_1.__assign(tslib_1.__assign({ zIndex: zIndex }, popContentStyle), contentPosition), onClick: _this.hide, onTouchMove: _this.stopPropagation, ref: _this.contentRef }, popContent),
                    h("div", { className: arrowClasses, ref: _this.arrowRef, style: tslib_1.__assign(tslib_1.__assign({ zIndex: zIndex }, arrowStyle), arrowPosition) })), document.body)));
        };
        return _this;
    }
    Popover.getDerivedStateFromProps = function (props, state) {
        if (props.disabled) {
            return { visible: false };
        }
        return null;
    };
    Popover.prototype.componentDidMount = function () {
        this.forceUpdate();
    };
    Popover.prototype.isVisible = function () {
        var forceVisible = this.props.visible;
        var stateVisible = this.state.visible;
        return typeof forceVisible === 'boolean' ? forceVisible : stateVisible;
    };
    Popover.prototype.determineVisibleChange = function (visible) {
        var _this = this;
        if (visible !== this.isVisible()) {
            return function () { return _this.props.onVisibleChange(visible); };
        }
    };
    Popover.prototype.calcPosition = function () {
        var _a = this.props, placement = _a.placement, alignBase = _a.alignBase, alignment = _a.alignment, offset = _a.offset, arrowOffset = _a.arrowOffset;
        var anchorDom = this.anchorRef.current;
        if (!anchorDom || !this.isVisible()) {
            return this.prevPostionInfo;
        }
        var arrowDom = this.arrowRef.current;
        var contentDom = this.contentRef.current;
        var _b = anchorDom.getBoundingClientRect(), left = _b.left, right = _b.right, top = _b.top, bottom = _b.bottom;
        var arrowDiagonal = arrowDom.getBoundingClientRect().height;
        var _c = contentDom.getBoundingClientRect(), contentHeight = _c.height, contentWidth = _c.width;
        var _d = document.body.getBoundingClientRect(), bodyLeft = _d.left, bodyRight = _d.right;
        var arrowLength = arrowDiagonal / Math.SQRT2;
        var arrowLeft = window.pageXOffset + arrowOffset + (left + right - arrowLength) / 2;
        var arrowTop = window.pageYOffset;
        var contentTop = 0;
        var resolvedPlacement = placement;
        if (resolvedPlacement === 'auto') {
            var maxBottom = window.innerHeight;
            var reachedBottom = bottom + ARROW_GAP + arrowLength / 2 + contentHeight;
            resolvedPlacement = reachedBottom < maxBottom ? 'bottom' : 'top';
        }
        if (resolvedPlacement === 'bottom') {
            arrowTop += bottom + ARROW_GAP;
            contentTop = arrowTop + arrowLength / 2;
        }
        else if (resolvedPlacement === 'top') {
            arrowTop += top - ARROW_GAP - arrowLength;
            contentTop = arrowTop + arrowLength / 2 - contentHeight;
        }
        var contentLeft = window.pageXOffset + offset;
        if (alignBase === 'default') {
            if (alignment === 'center') {
                contentLeft += (left + right - contentWidth) / 2;
            }
            else if (alignment === 'left') {
                contentLeft += left;
            }
            else if (alignment === 'right') {
                contentLeft += right - contentWidth;
            }
        }
        else if (alignBase === 'viewport') {
            if (alignment === 'center') {
                contentLeft += (bodyLeft + bodyRight - contentWidth) / 2;
            }
            else if (alignment === 'left') {
                contentLeft += CONTENT_MARGIN;
            }
            else if (alignment === 'right') {
                contentLeft += (bodyRight + bodyLeft) - contentWidth - CONTENT_MARGIN;
            }
        }
        this.prevPostionInfo = {
            arrowPosition: { left: arrowLeft + "px", top: arrowTop + "px" },
            contentPosition: { left: contentLeft + "px", top: contentTop + "px" },
            resolvedPlacement: resolvedPlacement
        };
        return this.prevPostionInfo;
    };
    Popover.prototype.render = function () {
        return theme_1.consumeTheme(this.themedRender);
    };
    return Popover;
}(React.Component));
exports.default = Popover;
Popover.defaultProps = {
    prefixCls: 'dui-m-popover',
    alignment: 'center',
    disabled: false,
    offset: 0,
    onVisibleChange: helper_1.emptyFn,
    placement: 'bottom',
    alignBase: 'default',
    arrowOffset: 0
};
Popover.propTypes = {
    prefixCls: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    alignment: PropTypes.oneOf(['left', 'center', 'right']),
    disabled: PropTypes.bool,
    offset: PropTypes.number,
    onVisibleChange: PropTypes.func,
    placement: PropTypes.oneOf(['top', 'bottom', 'auto']),
    popContent: PropTypes.node,
    visible: PropTypes.bool,
    alignBase: PropTypes.oneOf(['default', 'viewport']),
    popContentStyle: PropTypes.object,
    arrowStyle: PropTypes.object,
    arrowOffset: PropTypes.number,
    zIndex: PropTypes.number
};
